import React, { useState, useEffect } from "react";
import { Checkbox, TextInput } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "../CustomCampaignShowContainer";

export default () => {
  const {
    selectedNodeFormState,
    setSelectedNodeFormState,
  } = useCustomCampaignShowContext();

  const [thresholdPercentage, setThresholdPercentage] = useState(0);
  const [ignoreSoldOut, setIgnoreSoldOut] = useState(false);

  useEffect(() => {
    setThresholdPercentage(selectedNodeFormState?.node_data?.threshold_percentage || 10);
    setIgnoreSoldOut(!!selectedNodeFormState?.node_data?.ignore_sold_out);
  }, [selectedNodeFormState]);

  useEffect(() => {
    const debounceUpdateThresholdPercentage = _.debounce(() => {
      setSelectedNodeFormState({
        ...selectedNodeFormState,
        node_data: {
          ...selectedNodeFormState.node_data,
          threshold_percentage: thresholdPercentage,
        },
      });
    }, 500);

    debounceUpdateThresholdPercentage();

    return () => {
      debounceUpdateThresholdPercentage.cancel();
    };
  }, [thresholdPercentage]);

  const updateIgnoreSoldOut = (checked) => {
    setIgnoreSoldOut(checked);
    setSelectedNodeFormState({
      ...selectedNodeFormState,
      node_data: {
        ...selectedNodeFormState.node_data,
        ignore_sold_out: checked,
      },
    });
  };

  return (
    <>
      <TextInput
        label="Percentage of tickets remaining"
        inputMode="numeric"
        trailingText="%"
        value={String(thresholdPercentage)}
        placeholder="0"
        onChange={(e) => {
          const digits = e.target.value.replace(/\D/g, "");
          if (digits.length > 2) return;
          setThresholdPercentage(parseInt(digits || "0", 10));
        }}
        onFocus={(e) => e.target.select()}
      />
      <Checkbox
        label={(
          <span style={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <span>Ignore sold out shows</span>
            <span style={{ fontSize: 12, lineHeight: "18px", color: "var(--sl-text-tertiary)" }}>
              Skip triggering for events that are completely sold out
            </span>
          </span>
        )}
        checked={ignoreSoldOut}
        onChange={(e) => updateIgnoreSoldOut(e.target.checked)}
      />
    </>
  );
};
